import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PageDescriptionProps {
  children: ReactNode
  className?: string
}

/**
 * Subtle one-liner sitting under a page's tab nav (or under the page
 * title where there isn't one) to explain what the tool does. Kept as
 * a tiny shared primitive so every Generate / Edit page renders the
 * same typographic treatment without copy-pasted classes. Spacing is
 * intentionally left to the caller — different layout contexts (under
 * tabs vs above a form) want different margins.
 */
export function PageDescription({ children, className }: PageDescriptionProps) {
  return (
    <p className={cn('text-base text-[#888]', className)}>{children}</p>
  )
}
